import React, { useRef, useState } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { getPrivacyPolicyEmbedCode, copyToClipboard } from './embedUtils';
import { toast } from 'sonner';

interface EmbedPopoverProps {
  row: any;
  buttonId?: string;
}

export const EmbedPopover: React.FC<EmbedPopoverProps> = ({ row, buttonId }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Extract companyId
  const companyId = (window.activeTenancy?.id || window.companyID || row.original.companyId || '').toString();
  const embedUrl = `https://login.deiterate.com/js/external-js/epp/privacy-policy.js?customerId=${companyId}`;

  const handleCopy = async () => {
    if (inputRef.current) {
      inputRef.current.select();
    }
    const success = await copyToClipboard(embedUrl);
    setCopied(success);
    if (success && toast) {
      toast.success('Copied Privacy Policy embed URL! Paste this <script> tag into your website.', { duration: 5000 });
    }
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button 
          id={buttonId}
          variant="ghost" 
          size="icon" 
          title="Copy Privacy Policy Embed URL" 
          onClick={e => e.stopPropagation()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 17l4 4 4-4m0-5V3m-8 9h8" /></svg>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80">
        <div className="mb-2 font-medium">Embed Privacy Policy</div>
        <div className="flex items-center gap-2">
          <Input ref={inputRef} value={embedUrl} readOnly onClick={e => (e.target as HTMLInputElement).select()} className="flex-1 text-xs" />
          <Button size="sm" variant="outline" onClick={handleCopy}>{copied ? 'Copied!' : 'Copy'}</Button>
        </div>
        <div className="text-xs text-gray-500 mt-2">
          Paste this URL in a <code>&lt;script src="..."&gt;</code> tag on your website.<br />
          Example:<br />
          <code>{`<script src="${embedUrl}"></script>`}</code>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default EmbedPopover;
